export default {
  SET_COUPON_LIST(state, couponListData) {
    state.couponListData = couponListData;
  },
  ADD_COUPON_LIST(state, couponListData) {
    const uniqueCouponListData = couponListData.list.filter(newItem => !state.couponListData.list.some(oldItem => oldItem.id === newItem.id));
    state.couponListData.list = state.couponListData.list.concat(uniqueCouponListData);
    state.couponListData.count = couponListData.count;
  },
  RESET_STATE(state) {
    Object.assign(state, initialState());
  },
};

export const initialState = () => ({
  couponListData: { list: [], count: 0 },
});
